// extracted by mini-css-extract-plugin
module.exports = {"button":"PrimaryButton_button__2YtFu","container":"PrimaryButton_container__19fW5"};